var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 9.5,
    fill: "#E8E8EA",
    stroke: "#E8E8EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2495 33.5312C18.6486 33.5312 17.2246 32.5061 16.7075 30.9801L16.6725 30.8651C16.5505 30.461 16.4994 30.1211 16.4994 29.7811V22.9628L14.0734 31.061C13.7614 32.2521 14.4724 33.487 15.6654 33.8161L31.1288 37.9573C31.3218 38.0073 31.5148 38.0313 31.7049 38.0313C32.7008 38.0313 33.6109 37.3703 33.866 36.3961L34.7669 33.5312H20.2495Z",
    fill: "#B0AFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 23.0309C24.1027 23.0309 24.9996 22.1339 24.9996 21.0308C24.9996 19.9277 24.1027 19.0307 22.9997 19.0307C21.8966 19.0307 20.9996 19.9277 20.9996 21.0308C20.9996 22.1339 21.8966 23.0309 22.9997 23.0309Z",
    fill: "#B0AFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 16.0306H20.4995C19.1216 16.0306 17.9995 17.1527 17.9995 18.5308V29.5309C17.9995 30.909 19.1216 32.0311 20.4995 32.0311H35.4999C36.8779 32.0311 38 30.909 38 29.5309V18.5308C38 17.1527 36.8779 16.0306 35.4999 16.0306V16.0306ZM20.4995 18.0307H35.4999C35.776 18.0307 35.9999 18.2547 35.9999 18.5308V25.63L32.8409 21.9438C32.5058 21.5508 32.0208 21.3408 31.4998 21.3289C30.9818 21.3318 30.4958 21.5618 30.1638 21.9599L26.4496 26.4179L25.2396 25.2108C24.5557 24.5269 23.4426 24.5269 22.7596 25.2108L19.9996 27.9699V18.5308C19.9996 18.2547 20.2235 18.0307 20.4995 18.0307V18.0307Z",
    fill: "#B0AFB5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.fc004e4dc8a1cd2e954b71938eced27b.svg";
export { ForwardRef as ReactComponent };